import React from 'react';

const FormPage = () => {
  return <div />;
};

export default FormPage;
